import * as THREE from 'three'

export class Renderer{

    constructor(){

        this.Canvas = document.querySelector("canvas.webgl");

        this.sizes = {
            width: window.innerWidth,
            height: window.innerHeight
        };

        this.Scene = new THREE.Scene();

        this.Renderer = new THREE.WebGLRenderer({canvas: this.Canvas, antialias: true });
        this.Renderer.setSize(this.sizes.width, this.sizes.height);
        this.Renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
        this.Renderer.outputColorSpace = THREE.SRGBColorSpace;

        this.Camera = new THREE.PerspectiveCamera(75, this.sizes.width / this.sizes.height, 0.1, 1000);

        window.addEventListener('resize', () =>
        {
            // Update sizes
            this.sizes.width = window.innerWidth;
            this.sizes.height = window.innerHeight;

            // Update camera
            this.Camera.aspect = this.sizes.width / this.sizes.height;
            this.Camera.updateProjectionMatrix();

            // Update renderer
            this.Renderer.setSize(this.sizes.width, this.sizes.height);
            this.Renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
        });

    }

    Render(){

        this.Renderer.render(this.Scene, this.Camera);

    }

}